import { TweenMax } from 'gsap'
import $ from 'zepto-modules'
import Timeline from './components/timeline.js'
import ScrollMagic from 'scrollmagic'
import './libs/froogaloop.js'
require('animation.gsap')
require('debug.addIndicators')

/*
  All animations
*/
const animationHeader = () => {
  let controller = new ScrollMagic.Controller()

  let mask = TweenMax.fromTo('.header-mask', 0.6, {
    opacity: 0
  }, {
    opacity: 0.7
  })

  let scroll = TweenMax.to('.header-scroll', 0.6, {
    opacity: 0
  })

  let size = $('main').height()
  // console.log(size)

  let scene = new ScrollMagic.Scene({
    triggerElement: '.section-header',
    offset: size / 2.2
  })
    .setTween([mask, scroll])
    // .addIndicators()
    .addTo(controller)
}

const App = () => {
  var iframe = $('.video-desktop iframe')[0]
  var player = $f(iframe)
  let vH = $(window).height()
  let sectionLogo = $('.section-logo')
  let sectionLinks = $('.section-links')
  let svg = $('.section-logo text, .section-logo path, .section-logo polyline')
  let linkWeb = $('.linkWeb a')
  let activeState = false
  let treshold = 40 // Extra margin in pixels that triggers the color change
  let mobileFixed = $('.mobile-fixed')
  let headerMask = $('.header-mask')
  let sectionHeader = $('.section-header')

  let videoDesktop = $('.video-desktop')

  videoDesktop.on('click', () => {
    if (videoDesktop.hasClass('video-pause')) {
      player.api('play')
      videoDesktop.removeClass('video-pause')
      videoDesktop.addClass('video-play')
    } else if (videoDesktop.hasClass('video-play')) {
      player.api('pause')
      videoDesktop.removeClass('video-play')
      videoDesktop.addClass('video-pause')
    }
  })

  // init clip timeline-about
  TweenMax.set($('.timeline-about'), {
    clip: 'rect(525px,728px,0px,0px)'
  })

  function smoothScroll (el, to, duration) {
    if (duration < 0) {
      return
    }
    var difference = to - $(window).scrollTop()
    var perTick = difference / duration * 10
    setTimeout(function () {
      if (!isNaN(parseInt(perTick, 10))) {
        window.scrollTo(0, $(window).scrollTop() + perTick)
        smoothScroll(el, to, duration - 10)
      }
    }.bind(this), 10)
  }

  $('.backtop').on('click', (e) => {
    e.preventDefault()
    smoothScroll($(window), 0, 400)
  })

  let wWidth = $(window).width()

  if (wWidth >= 1100) {
    setTimeout(Timeline, 500)
  }

  $(window).on('resize', (e) => {
    let wWidthR = $(window).width()
    if (wWidthR === 1100) {
      window.location.reload()
    }
    if (wWidthR === 1101) {
      setTimeout(Timeline, 500)
    }
  })

  $(document).on('scroll', (e) => {
    let distanceScrolled = $('body').parent().scrollTop()

    if (distanceScrolled > (vH - treshold) && !activeState) {
      sectionLogo.addClass('hover-yellow')
      sectionLinks.addClass('hover-yellow')
      // let black = '#000000'
      // svg.forEach((v, i) => {
      //   $(v).attr('style', 'fill:' + black)
      // })
      // linkWeb.css({
      //   'border': `2px solid ${black}`,
      //   'color': black
      // })

      activeState = true
    }

    if (distanceScrolled > (vH - 100)) {
      mobileFixed.addClass('is-fixed')
    }
    if (distanceScrolled < (vH - 100)) {
      mobileFixed.removeClass('is-fixed')
    }

    if (distanceScrolled < (vH - treshold) && activeState) {
      sectionLogo.removeClass('hover-yellow')
      sectionLinks.removeClass('hover-yellow')
      // let white = '#ffffff'
      // svg.forEach((v, i) => {
      //   $(v).attr('style', 'fill:' + white)
      // })
      // linkWeb.css({
      //   'border': `2px solid ${white}`,
      //   'color': white
      // })

      activeState = false
    }

    if (distanceScrolled < vH) {
      headerMask.css('opacity', distanceScrolled / vH)
      sectionHeader.css('transform', `scale(${1 - (distanceScrolled / vH) * 0.1})`)
    }
  })
}

App()



// WEBPACK FOOTER //
// ./src/app.js